import * as yup from 'yup';
import { urlRegex, ipRegex, numbericRegex } from '../regex';

export const xinshiSignupFormValidator = yup.object().shape({
  // email: yup.string().email().required(),
  email: yup.string()
    .max(256)
    .email()
    .trim()
    .lowercase()
    .required(),
  countryDialCode: yup.string()
    .max(256)
    .matches(numbericRegex, 'not valid')
    .trim()
    .required(),
  number: yup.string()
    .matches(numbericRegex, 'not valid')
    .trim()
    .required(),
  verificationCode: yup.string()
    .matches(numbericRegex, 'not valid')
    .trim()
    .required(),
  password: yup.string()
    .min(8)
    .max(32)
    .required(),
  confirmPassword: yup.string()
    .min(8)
    .max(32)
    .required()
    .test('matchPasswords', 'Passwords do not match',
      // eslint-disable-next-line
      function (confirmPassword) {
        return this.parent.password === confirmPassword;
      })
});

export const xinshiProfileFormValidator = yup.object().shape({
  name: yup.string().max(32).required(),
  position: yup.string().max(32).oneOf([
    'student',
    'employee'
  ]),
  // eslint-disable-next-line
  college: yup.string().max(32).test('valid', function (value) {
    const { companyName } = this.parent;
    if (!companyName) return !!value;
    return true;
  }),
  // eslint-disable-next-line
  companyName: yup.string().max(32).test('valid', function (value) {
    const { college } = this.parent;
    if (!college) return !!value;
    return true;
  }),
  major: yup.string().max(32),
  role: yup.string().max(32).required().oneOf([
    '设计师',
    '产品经理',
    '商业策划',
    '工程师'
  ]),
  awards: yup.array().of(yup.string().max(32)),
  patents: yup.array().of(yup.string().max(32)),
  socialMedia: yup.object(),
  websiteUrl: yup.string()// .url(translate('form.error.string.url'))
    .test(
      'validUrl',
      // eslint-disable-next-line func-names, prefer-arrow-callback
      function (value) {
        return !value || urlRegex.test(value) || ipRegex.test(value);
      }
    )
});




// WEBPACK FOOTER //
// ./src/components/forms/validators/index.js